import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";
import { config } from "../../config";
import { getUserKey } from "../../utils/auth";
import { toast } from "react-toastify";

function startMeeting({
    signature,
    client,
    sdkKey,
    meetingNumber,
    passWord,
    userName,
    userEmail,
}) {
    let meetingSDKElement = document.getElementById("meetingSDKElement");

    client.init({
        debug: true,
        zoomAppRoot: meetingSDKElement,
        language: "en-US",
    });

    client.join({
        sdkKey: sdkKey,
        signature: signature,
        meetingNumber: meetingNumber,
        password: passWord,
        userName: userName,
        userEmail: userEmail,
    });
}

const Meeting = () => {
    const location = useLocation();
    const userData = getUserKey();
    const client = ZoomMtgEmbedded.createClient();

    // Retrieve state from navigation
    const meetingNumber = location.state?.meetingId || "";
    const passWord = location.state?.meetingPass || "";
    const signature = location.state?.zoomSignature || "";
    // Note: ReactDemo7 used an appKey dynamically or statically configured. 
    // We will use the config object or fallback to the one passed in state.
    const sdkKey = location.state?.appKey || config.zoomSdkKey || "Egz3OjF7ITKvLvhHxRhxLNa5us9uJQ24oJX7";

    const userName = userData?.name || "Attendee";
    const userEmail = userData?.email || "";

    useEffect(() => {
        if (!signature || !meetingNumber) {
            toast.error("Invalid meeting credentials. Please try joining the event again.");
            return;
        }

        try {
            startMeeting({
                signature,
                client,
                sdkKey,
                meetingNumber,
                passWord,
                userName,
                userEmail,
            });
        } catch (e) {
            console.error("Zoom start meeting error: ", e);
            toast.error("Failed to start the Zoom Meeting.");
        }
    }, [signature, meetingNumber, client, sdkKey, passWord, userName, userEmail]);

    return (
        <div className="App" style={{ minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#000" }}>
            <main style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                <h1 style={{ color: "white", padding: "10px", textAlign: "center" }}>Joining Event...</h1>
                <div
                    id="meetingSDKElement"
                    style={{ flex: 1, width: "100%", height: "100%", minHeight: "600px" }}>
                    {/* Zoom Meeting SDK Component View Rendered Here */}
                </div>
            </main>
        </div>
    );
};

export default Meeting;
